import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

function Dropdown({ children }) {
  return (
    <DropdownMenu>
      {children}
    </DropdownMenu>
  );
}

function Toggle({ children, className, ...props }) {
  return (
    <DropdownMenuTrigger asChild {...props}>
      <button type="button" className={cn('c-dropdown__toggle', className)}>
        {children}
      </button>
    </DropdownMenuTrigger>
  );
}

function Content({ children, ...props }) {
  return (
    <DropdownMenuContent align="end" {...props}>
      {children}
    </DropdownMenuContent>
  );
}

function Item({ to, children, onClick, ...props }) {
  const navigate = useNavigate();

  const handleClick = to ? () => navigate(to) : onClick;

  return (
    <DropdownMenuItem
      onClick={handleClick}
      className="cursor-pointer"
      {...props}
    >
      {children}
    </DropdownMenuItem>
  );
}

Dropdown.Toggle = Toggle;
Dropdown.Content = Content;
Dropdown.Item = Item;
Dropdown.displayName = 'LegacyDropdownAdapter';

export default Dropdown;
